import React, { useState, useEffect } from "react";
import { Modal, Button, CloseButton } from "react-bootstrap";
import swal from "sweetalert";
import { updateQRTemplate } from "../../../../components/pages/campaigns/services";

const UpdateStatusModal = ({ show, close, item, onUpdated }) => {
    const [status, setStatus] = useState("Open");
    const [remark, setRemark] = useState("");
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        if (show && item) {
            setStatus(item?.requestData?.status || "Open");
            setRemark(item?.requestData?.remark || "");
        }
    }, [show, item]);

    const handleSubmit = async () => {
        if (!remark.trim()) {
            swal({
                title: "Oops!",
                text: "Please enter a remark",
                icon: "error",
                button: "OK",
            });
            return;
        }

        setLoader(true);

        let tempToken = JSON.parse(localStorage.getItem("token_gen"));

        const body = {
            ...item,
            requestData: {
                ...item?.requestData,
                status,
                remark,
            },
        };

        const res = await updateQRTemplate(
            tempToken?.access_token,
            item?.id,
            body
        );

        setLoader(false);

        if (res?.message === "Update Success" || res?.message === "Success") {
            swal({
                title: "Success",
                text: "Status updated successfully",
                icon: "success",
                button: "OK",
                timer: 3000,
            });
            onUpdated(body);
            close();
        } else {
            swal({
                title: "Oops!",
                text: res?.message || "Something went wrong",
                icon: "error",
                button: "OK",
            });
        }
    };

    return (
        <Modal show={show} onHide={close} centered>
            <Modal.Header>
                <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>
                    Update Status
                </Modal.Title>
                <CloseButton onClick={close} variant="black" />
            </Modal.Header>

            <Modal.Body>
                <div className="form-group">
                    <label>Query Status</label>
                    <select
                        className="form-control"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        <option value="Open">Open</option>
                        <option value="Close">Close</option>
                    </select>
                </div>

                <div className="form-group" style={{ marginTop: "15px" }}>
                    <label>Remark</label>
                    <textarea
                        className="form-control"
                        rows={4}
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        placeholder="Enter remark"
                    />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={close}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit} disabled={loader}>
                    {loader ? "Updating..." : "Update"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UpdateStatusModal;
